module.exports = __webpack_public_path__ + "resources/img/sign-img.9a0175a4.png";